import React from 'react';
import { render } from 'react-dom';
import './index.css';
import { ConsentRoot } from './ConsentRoot';

render(<ConsentRoot />, document.getElementById('root'));
